var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "back-profile",
        {
          nativeOn: {
            click: function($event) {
              return _vm.navigateTo("app.profile.home")
            }
          }
        },
        [_vm._v("Perfil de " + _vm._s(_vm.studentProfile.student.name))]
      ),
      _vm._v(" "),
      _c(
        "block",
        [
          _c("template", { slot: "header" }, [_vm._v("Notas")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grades" },
            _vm._l(_vm.reversedTerms, function(t) {
              return _c(
                "div",
                { key: t.id, staticClass: "term-grades" },
                [
                  _c("div", { staticClass: "term" }, [_vm._v(_vm._s(t.name))]),
                  _vm._v(" "),
                  _c("term-grades-table", {
                    attrs: {
                      snapshots: _vm.snapshots,
                      grades: _vm.gradesByTerm[t.id],
                      gradeThreshold: _vm.settings.deficientGradeThreshold
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }